import script from "./form-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-group.vue?vue&type=script&setup=true&lang=ts"

import "./form-group.vue?vue&type=style&index=0&id=98ac6c88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98ac6c88"]])

export default __exports__